import { useEffect, useState } from 'react';

import LabelContainer from '../label-container';
import ErrorContainer from '../error-container';

export default (props) => {
    let { label, fill, grow, wordCount = false, minWords = 0, maxWords = 0, onChange = () => {}, containerStyle = {} } = props;

    const [ countLabel, setCountLabel ] = useState('');

    if (props?.id === undefined && props?.name !== undefined) {
        props = {
            ...props,
            id: props?.name
        }
    }
    
    return (
        <LabelContainer label={wordCount ? countLabel : label} fill={fill} grow={grow} style={containerStyle}>
            <ErrorContainer errors={props?.errors} fill={fill}>
                <input autoComplete="off" className="inputs-text" { ...props } onChange={(e) => {
                    onChange(e);
                    
                    if (wordCount) {
                        setCountLabel(`Word Count: ${e.target.value.split(' ').length}/${maxWords}`)
                    }
                }}/>
            </ErrorContainer>
        </LabelContainer>
    )
}
